<template>
  <div
    class="logo-container d-flex justify-center"
    :style="{ height: appStateStore.navCollapsed ? 'auto' : '90px' }">
    <div v-if="loggedIn">
      <v-fab
        variant="text"
        size="small"
        rounded="circle"
        icon="mdi-menu"
        class="mt-2"
        location="top left"
        :absolute="!appStateStore.navCollapsed"
        :class="{ 'ml-2': !appStateStore.navCollapsed }"
        @click="appStateStore.setNavCollapsed(!appStateStore.navCollapsed)" />
    </div>
    <template v-if="!appStateStore.navCollapsed || !loggedIn">
      <img
        v-if="platformTheme === 'deeproot'"
        width="70%"
        class="cursor-pointer"
        alt="Deeproot Logo"
        transition="scale-transition"
        :src="DeeprootLogo"
        @click="goHome" />
      <img
        v-else-if="!loggedIn"
        height="45"
        class="ml-12 mt-6 mr-4"
        alt="Tunnl Logo"
        transition="scale-transition"
        :src="TunnlHaloLogo" />
      <img
        v-else
        height="35"
        class="cursor-pointer mt-5"
        alt="Tunnl Logo"
        transition="scale-transition"
        :src="TunnlLogo"
        @click="goHome" />
      <div class="align-self-center">
        <span
          v-if="environmentBadge"
          class="env-badge"
          :class="{ unauthed: !loggedIn }">
          {{ environmentBadge }}
        </span>
      </div>
    </template>
  </div>
  <v-divider
    v-if="!appStateStore.navCollapsed"
    color="primary"
    class="nav-divider" />
</template>

<script>
import { mapStores } from "pinia";
import { useAppStateStore } from "@/stores/AppStateStore";
import { userTierMixin } from "@/mixins/UserTier";
import DeeprootLogo from "@/assets/DEEP_ROOT_Primary_Green_Gray_RGB.png";
import TunnlLogo from "@/assets/TUNNL_Primary_Blue_RGB.png";
import TunnlHaloLogo from "@/assets/Tunnl_Halo_Logo.png";

export default {
  name: "Logo",
  mixins: [userTierMixin],
  emits: ["clicked"],
  data: () => ({
    DeeprootLogo,
    TunnlLogo,
    TunnlHaloLogo,
  }),
  computed: {
    ...mapStores(useAppStateStore),
    environmentBadge() {
      // Don't show a badge in production
      if (import.meta.env.VITE_MODE === "production") {
        return undefined;
      } else {
        return import.meta.env.VITE_MODE;
      }
    },
  },
  methods: {
    goHome() {
      if (!this.loggedIn || this.$route.name === "home") return;
      this.$router.push({ name: "home" });
      this.$emit("clicked");
    },
  },
};
</script>

<style lang="scss" scoped>
.logo-container {
  position: relative;
  .env-badge {
    position: absolute;
    top: 76px;
    right: 16px;
    font-family: "Barlow", sans-serif;
    font-size: 13px;
    letter-spacing: 0.1px;
    padding: 2px 6px;
    border: 1px solid rgb(var(--v-theme-primary));
    border-radius: 4px;
    text-transform: uppercase;
    color: rgb(var(--v-theme-primary));
    background-color: rgb(var(--v-theme-background-gray));
    z-index: 1;
    &.unauthed {
      position: static;
      background-color: rgb(var(--v-theme-background));
    }
  }
}
.nav-divider {
  margin-bottom: 12px;
}
</style>
